export const findEarliestRenewalSubscription = (subscriptions, productApiNames) => {
  const earliestSubscription = subscriptions.filter(subscription => productApiNames.includes(subscription.productApiName)).reduce((earliest, current) => {
    return new Date(current.subscriptionRenewalDate) < new Date(earliest.subscriptionRenewalDate) ? current : earliest;
  });
  return earliestSubscription;
};